import { render } from "./image.md?vue&type=template&id=197cc283"
import script from "./image.md?vue&type=script&lang=js"
export * from "./image.md?vue&type=script&lang=js"
script.render = render

export default script